import { render } from "./NewColorScreen.vue?vue&type=template&id=6864a476&scoped=true"
import script from "./NewColorScreen.vue?vue&type=script&lang=js"
export * from "./NewColorScreen.vue?vue&type=script&lang=js"

import "./NewColorScreen.vue?vue&type=style&index=0&id=6864a476&lang=scss"
import "./NewColorScreen.vue?vue&type=style&index=1&id=6864a476&scoped=true&lang=scss"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6864a476"]])

export default __exports__